import React from 'react';

export default function LogoWhite() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="133"
      height="44"
      viewBox="0 0 133 44"
      fill="none"
    >
      <path
        d="M61.6948 15.4558C60.3375 14.0986 58.4463 13.418 56.0172 13.418H50.0859V16.3223H56.0172C56.8008 16.3223 57.4661 16.4453 58.008 16.6899C58.5459 16.9318 58.9881 17.2749 59.3308 17.7191C59.6694 18.1619 59.9191 18.7045 60.0732 19.3523C60.2312 20.0015 60.3082 20.7218 60.3082 21.5118C60.3082 22.3017 60.2193 23.0507 60.0426 23.6958C59.862 24.345 59.5858 24.9067 59.2086 25.3769C58.8314 25.8511 58.336 26.212 57.7291 26.4648C57.1222 26.7136 56.3917 26.8407 55.5298 26.8407H53.3969V19.0393H50.0873V29.7436H55.4647C56.753 29.7436 57.9097 29.57 58.9323 29.2174C59.951 28.8689 60.8196 28.3427 61.5314 27.6429C62.2419 26.9391 62.7851 26.0808 63.165 25.0557C63.5421 24.0348 63.7307 22.8484 63.7307 21.4913C63.7307 18.8207 63.0547 16.8116 61.6974 15.4544L61.6948 15.4558Z"
        fill="white"
      />
      <path
        d="M70.2315 26.842V22.8184H77.2969V19.8908H70.2315V16.3223H77.7432V13.418H66.9219V29.7436H77.4935L78.208 26.8393H70.2315V26.842Z"
        fill="white"
      />
      <path
        d="M84.333 26.842V22.8184H91.3985V19.8908H84.333V16.3223H91.8447V13.418H81.0234V29.7436H91.5911L92.3095 26.8393H84.333V26.842Z"
        fill="white"
      />
      <path
        d="M106.671 16.5874C106.483 15.9697 106.16 15.4284 105.691 14.961C105.226 14.4977 104.596 14.1218 103.804 13.8417C103.013 13.5615 102.005 13.418 100.795 13.418H95.125V29.7436H98.3921V23.9131H100.884C102.068 23.9131 103.048 23.771 103.828 23.4826C104.605 23.1901 105.228 22.7979 105.693 22.3031C106.161 21.8084 106.484 21.2316 106.673 20.5742C106.857 19.9209 106.949 19.2334 106.949 18.5173C106.949 17.8489 106.857 17.2038 106.673 16.5874H106.671ZM103.557 19.6065C103.476 19.9195 103.326 20.1806 103.103 20.3938C102.88 20.607 102.58 20.7778 102.204 20.8967C101.823 21.0197 101.347 21.0826 100.769 21.0826H98.3894V16.2321H100.745C101.322 16.2321 101.803 16.2881 102.18 16.3906C102.557 16.4972 102.856 16.6517 103.079 16.8498C103.302 17.048 103.456 17.2927 103.544 17.581C103.633 17.8694 103.678 18.2056 103.678 18.5856C103.678 18.9655 103.635 19.2936 103.554 19.6065H103.557Z"
        fill="white"
      />
      <path
        d="M113.122 26.8174V13.418H109.812V29.7436H119.891L120.634 26.8161H113.122V26.8174Z"
        fill="white"
      />
      <path
        d="M129.496 13.418L125.963 20.0289L122.538 13.418H118.852L124.337 23.0903V29.7436H127.65V23.0903L133.005 13.418H129.495H129.496Z"
        fill="white"
      />
      <path
        d="M26.288 3.23442C26.288 2.00254 25.3176 1.00391 24.1206 1.00391C22.9235 1.00391 21.9531 2.00254 21.9531 3.23442V29.1668C21.9531 30.3987 22.9235 31.3973 24.1206 31.3973C25.3176 31.3973 26.288 30.3987 26.288 29.1668V3.23442Z"
        fill="#F73753"
      />
      <path
        d="M18.9677 23.4961C18.9677 22.2643 17.9973 21.2656 16.8003 21.2656C15.6032 21.2656 14.6328 22.2643 14.6328 23.4961V39.9325C14.6328 41.1644 15.6032 42.163 16.8003 42.163C17.9973 42.163 18.9677 41.1644 18.9677 39.9325V23.4961Z"
        fill="#F73753"
      />
      <path
        d="M33.6083 15.2774C33.6083 14.0455 32.6379 13.0469 31.4409 13.0469C30.2438 13.0469 29.2734 14.0455 29.2734 15.2774V27.2582C29.2734 28.4901 30.2438 29.4887 31.4409 29.4887C32.6379 29.4887 33.6083 28.4901 33.6083 27.2582V15.2774Z"
        fill="#F73753"
      />
      <path
        d="M33.6083 33.6289C33.6083 32.3971 32.6379 31.3984 31.4409 31.3984C30.2438 31.3984 29.2734 32.3971 29.2734 33.6289C29.2734 34.8608 30.2438 35.8595 31.4409 35.8595C32.6379 35.8595 33.6083 34.8608 33.6083 33.6289Z"
        fill="#F73753"
      />
      <path
        d="M18.9677 17.1836C18.9677 15.9518 17.9973 14.9531 16.8003 14.9531C15.6032 14.9531 14.6328 15.9518 14.6328 17.1836C14.6328 18.4155 15.6032 19.4141 16.8003 19.4141C17.9973 19.4141 18.9677 18.4155 18.9677 17.1836Z"
        fill="#F73753"
      />
      <path
        d="M40.9208 18.5235C40.9208 17.2916 39.9504 16.293 38.7534 16.293C37.5563 16.293 36.5859 17.2916 36.5859 18.5235V25.3435C36.5859 26.5754 37.5563 27.574 38.7534 27.574C39.9504 27.574 40.9208 26.5754 40.9208 25.3435V18.5235Z"
        fill="#F73753"
      />
      <path
        d="M4.33489 17.8204C4.33489 16.5885 3.36449 15.5898 2.16744 15.5898C0.970397 15.5898 0 16.5885 0 17.8204V24.6404C0 25.8722 0.970397 26.8709 2.16744 26.8709C3.36449 26.8709 4.33489 25.8722 4.33489 24.6404V17.8204Z"
        fill="#F73753"
      />
      <path
        d="M11.6552 21.6446C11.6552 20.4127 10.6848 19.4141 9.48776 19.4141C8.29071 19.4141 7.32031 20.4127 7.32031 21.6446V33.6254C7.32031 34.8572 8.29071 35.8559 9.48776 35.8559C10.6848 35.8559 11.6552 34.8572 11.6552 33.6254V21.6446Z"
        fill="#F73753"
      />
    </svg>
  );
}
